import { render, staticRenderFns } from "./BillsComponent.vue?vue&type=template&id=544d5244&scoped=true&"
import script from "./BillsComponent.vue?vue&type=script&lang=js&"
export * from "./BillsComponent.vue?vue&type=script&lang=js&"
import style0 from "./BillsComponent.vue?vue&type=style&index=0&id=544d5244&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544d5244",
  null
  
)

export default component.exports